import i18n from 'i18next';

// The customer's name for a stored Quote.status. Every page that prints a status
// reads it from here, so a raw code ("pending_approval") never reaches the
// screen. Called during render from outside any component, so it uses the
// i18next singleton rather than a hook's `t`.
export function quoteStatusLabel(status: string): string {
  switch (status) {
    case 'draft': return i18n.t('status:list.status.draft');
    case 'priced': return i18n.t('status:list.status.priced');
    case 'submitted': return i18n.t('status:list.status.submitted');
    case 'pending_approval': return i18n.t('status:list.status.pendingApproval');
    case 'awaiting_signature': return i18n.t('status:list.status.awaitingSignature');
    case 'signed': return i18n.t('status:list.status.signed');
    case 'signature_declined': return i18n.t('status:list.status.signatureDeclined');
    case 'approved': return i18n.t('status:list.status.approved');
    case 'declined': return i18n.t('status:list.status.declined');
    case 'paid': return i18n.t('status:list.status.paid');
    case 'cancelled': return i18n.t('status:list.status.cancelled');
    default: return status;
  }
}
